import React from 'react';
import OrgAnalytics from '../components/OrgAnalytics';

const OrgAnalyticsPage = () => (
  <OrgAnalytics />
);

export default OrgAnalyticsPage;
